import { render, staticRenderFns } from "./WebhookEventsCardTable.vue?vue&type=template&id=34e7bea6&scoped=true&lang=pug"
import script from "./WebhookEventsCardTable.vue?vue&type=script&lang=js"
export * from "./WebhookEventsCardTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e7bea6",
  null
  
)

export default component.exports